import {
  Avatar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { styled, useTheme } from "@mui/material/styles";
// import Localization from "components/localization";
import Sidebar from "components/sidebar";
import { PLACEHOLDER_IMAGE } from "constant";
import { subMenu } from "constant/menu";
import BarsIcon from "lib/assets/svg/bars";
import ChevronLeftIcon from "lib/assets/svg/chevron-left";
import ChevronRightIcon from "lib/assets/svg/chevron-right";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCount, getUser, getUserPlan } from "store/selector";
import { onSignOut } from "store/services";
import { actions } from "store/slice";
import { errorToaster, successToaster } from "utils/alerts";
import { trackEvent, AnalyticsEvents, resetUser } from "utils/analytics";
import { getItem, removeItem } from "utils/local-storage";
import {
  getIsFormChanged,
  getProfile,
  getProfileImage,
  getEditedProfileImage,
} from "view/profile/store/selector";
import { saveProfile } from "view/profile/store/services";
import useMediaQueryMUI from "@mui/material/useMediaQuery";
import PlanBadge, { getPlanColor } from "./plan-badge";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const MobileHeader = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQueryMUI("(max-width:900px)");
  const profileImage = useSelector(getProfileImage);
  const editedProfileImage = useSelector(getEditedProfileImage);
  const { token } = useSelector(getUser);
  const profileObj = useSelector(getProfile);
  const isFormChanged = useSelector(getIsFormChanged);
  const count = useSelector(getCount);
  const { plan } = useSelector(getUserPlan);
  const currentUser = getItem("current_user");

  const [open, setOpen] = useState(false);
  const [profileHover, setProfileHover] = useState(false);
  const sidebarRef = useRef(null);
  const dropdownmenuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Resolve plan display info
  const planColor = getPlanColor(plan);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClickSave = () => {
    dispatch(actions.setLoading(true));
    saveProfile(token, {
      ...profileObj,
      ...currentUser,
    })
      .then((res) => {
        dispatch(actions.setLoading(false));
        if (res.data.success) {
          successToaster("Profile Updated Successfully!!!", 4000);
          trackEvent(AnalyticsEvents.PROFILE_SAVE, { section: "profile_edit" });
          trackEvent("tutorial_step_complete", {
            tutorial_name: "registration_flow",
            step_name: "profile_update",
          });
        }
      })
      .catch(
        (err) =>
          err &&
          errorToaster(
            "Facing issue in saving profile. Please Try After Sometime!!!",
            4000
          )
      );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setOpen(false);
      }
      if (
        dropdownmenuRef.current &&
        !dropdownmenuRef.current.contains(event.target)
      ) {
        setProfileHover(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }} id={`sidebar`}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          style={{
            backgroundColor: "#f4f7fc",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => handleDrawerOpen()}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <BarsIcon style={{ color: "#000000", opacity: "0.5" }} />
          </IconButton>
          <nav
            className="navbar navbar-expand-lg"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <a className="navbar-brand" href="/" style={{ margin: 0 }}>
              <img
                src="https://res.cloudinary.com/dc3dylylv/image/upload/q_auto,f_auto/v1670433144/Logos/Kalyanawaran/Finalized_Logo_Kalyawaran_-_1725_x_353_guysdv.png"
                alt="kalyanawaran"
                className="mobile-header-logo"
                fetchpriority="high"
                loading="eager"
              />
            </a>
            <div
              // className="collapse navbar-collapse"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: isSmallScreen ? "center" : "flex-end",
              }}
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav ml-auto"
                style={{ alignItems: "center", flexDirection: "row" }}
              >
                {/* <Localization /> */}
                {token && (
                  <>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        if (token) {
                          trackEvent(AnalyticsEvents.LOGOUT);
                          resetUser();
                          removeItem("the_main_app");
                          removeItem("current_user");
                          onSignOut(token)
                            .then((res) => res)
                            .catch((err) => console.error("err", err));
                          window.location.reload(false);
                        }
                      }}
                    >
                      Logout
                    </button>
                    {location.pathname === "/profileedit" && (
                      <button
                        className="btn btn-primary"
                        style={{ marginRight: "10px" }}
                        onClick={handleClickSave}
                        disabled={!isFormChanged}
                      >
                        Save
                      </button>
                    )}
                  </>
                )}
                {token && (
                  <div style={{ cursor: "pointer", position: "relative" }}>
                    <IconButton
                      aria-haspopup="true"
                      color="inherit"
                      aria-controls="profile-menu"
                      onClick={() => setProfileHover(!profileHover)}
                    >
                      {/* AccountIcon  */}
                      <Avatar
                        alt="account-icon"
                        src={
                          (editedProfileImage || profileImage) === ""
                            ? PLACEHOLDER_IMAGE[50]
                            : editedProfileImage || profileImage
                        }
                      />
                    </IconButton>
                    {profileHover && (
                      <div
                        style={{
                          width: "max-content",
                          top: "55px",
                          right: "5px",
                          borderRadius: ".5rem",
                          boxShadow: " 0 3px 10px rgba(62, 85, 120, .045)",
                        }}
                        className="text-black  py-2 bg-white position-absolute"
                        ref={dropdownmenuRef}
                      >
                        <div className="border-bottom">
                          <div>
                            {(getItem("current_user")?.username ||
                              getItem("current_user")?.userId) && (
                              <div className="nav-item">
                                <b>User Info</b>
                              </div>
                            )}
                            {getItem("current_user")?.username && (
                              <h6 className="nav-item">
                                User Name:{" "}
                                <span
                                  style={{ fontStyle: "italic", opacity: ".5" }}
                                >
                                  {getItem("current_user")?.username || ""}
                                </span>
                              </h6>
                            )}
                            {getItem("current_user")?.userId && (
                              <h6 className="nav-item">
                                User Id:{" "}
                                <span
                                  style={{ fontStyle: "italic", opacity: ".5" }}
                                >
                                  {getItem("current_user")?.userId || ""}
                                </span>
                              </h6>
                            )}

                            {/* Plan Badge */}
                            <PlanBadge plan={plan} />

                            {subMenu.map(({ name, link }, index) => (
                              <h6
                                key={index}
                                className="nav-item"
                                onClick={() => navigate(link)}
                              >
                                {name}
                              </h6>
                            ))}
                            <h6
                              className="nav-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              Count:{" "}
                              <span
                                style={{ fontWeight: 700, color: planColor }}
                              >
                                {count}
                              </span>
                            </h6>
                          </div>
                        </div>
                        <div
                          onClick={() => {
                            if (token) {
                              removeItem("the_main_app");
                              removeItem("current_user");
                              onSignOut(token)
                                .then((res) => res)
                                .catch((err) => console.error("err", err));
                              window.location.reload(false);
                            }
                          }}
                        >
                          <h6 className="nav-item">Log Out</h6>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </ul>
            </div>
          </nav>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
        ref={sidebarRef}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Sidebar onClose={handleDrawerClose} />
      </Drawer>
    </Box>
  );
};

export default MobileHeader;
